import React from 'react'
import { MarkupLayout } from "../../ui/markupLayout/MarkupLayout"
import { Heading } from '../../ui/heading/Heading'
import { SparePartCard } from "../../ui/sparePartCard/SparePartCard"
import styles from "./sparePartsCardSection.module.css"
import { Button } from '../../ui/button/Button'

export function SparePartsCardSection() {


  const mockData = [{
    img: "/images/wiper1.webp",
    text: "Каркасные шетки",
    link: "/wiper-blades/carcass"
  }, {
    img: "/images/wiper3.webp",
    text: "Бескаркасные шетки",
    link: "/wiper-blades/withoutcarcass"
  }, {
    img: "/images/wiper2.webp",
    text: "Гибридные шетки",
    link: "/wiper-blades/hybrid"
  },]


  return (
    <section className={styles.spare_part_section}>
      <MarkupLayout>
        <Heading>Щетки стеклоочистителя</Heading>
        <div className={styles.card_container}>
          {mockData.map((item, id) => {
            return <SparePartCard img={item.img} text={item.text} height={"h-345"} width={"w-426"} key={id} link={item.link} />
          })}
        </div>
        <Button variant={"yellow"} width={"w-426"} behaviour={"link"} link={"/catalog"}>Каталог подбора </Button>
      </MarkupLayout>
    </section>
  )
}
